import {Component, ViewChild, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from "rxjs";
import { MatDialog } from '@angular/material/dialog';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatSidenav } from '@angular/material/sidenav';

import { AppService } from 'src/app/app.service';
import { AuthService } from 'src/app/_core/auth.service';
import { TabitPayService } from 'src/app/tabit-pay/tabit-pay.service';
import { DialogsService } from 'src/app/_services/dialogs.service';
import { OrderService } from 'src/app/_services/order.service';
import { OrderLoyaltyService } from 'src/app/_services/order-loyalty.service';
import {ActivatedRoute, Router} from '@angular/router';

import { MenuComponent } from 'src/app/order-items/menu/menu.component';
import { TabitOrderSummaryComponent } from 'src/app/tabit-order/tabit-order-summary/tabit-order-summary.component';
import { TabitOrderProcessService } from 'src/app/tabit-order/tabit-order-process.service';
import * as _ from "lodash";

@Component({
    selector: 'app-tabit-order',
    templateUrl: './tabit-order.component.html',
    styleUrl: './tabit-order.component.scss',
    standalone: false
})
export class TabitOrderComponent implements OnInit, OnDestroy {
	@ViewChild('appSidenav', { static: false }) public appSidenav: MatSidenav;
	@ViewChild(MenuComponent) menuComponent: MenuComponent;
	private signinSubscription: Subscription = null;
	$storage: any;
	loading: boolean = true;
	currentRoute: string;
	wizardStep = 0;
	stepsMap = {
		'menu': 0,
		'extras': 1,
		'tip': 2,
		'pay': 3,
		'end': 4
	}
	stepsMapTitles = ['...', 'TO.extraoffers_title', null, 'TO.pay_title']; ///*'TO.tip_title'*/
	hasExtras: boolean;

	constructor(
		public appService: AppService,
		public authService: AuthService,
		public tabitPayService: TabitPayService,
		public loyaltyService: OrderLoyaltyService,

		public dialog: MatDialog,
		private router: Router,
		private activatedRoute: ActivatedRoute,
		public dialogsService: DialogsService,
		private bottomSheet: MatBottomSheet,
		public orderService: OrderService,
		public orderProcess: TabitOrderProcessService,
	) {
		this.$storage = this.orderService.$storage;
		this.init(this.tabitPayService.$storage?.rosConfig);
		this.orderService.activityTimerSubject.subscribe(status => {
			if (this.wizardStep == this.stepsMap.end) {
				this.onOrderDone();
				return;
			}
			dialog.closeAll();
			switch (status) {
				case "timeout":
					this.appService.confirm({
						content: this.appService.translate('TD.msg_timeout'),
						confirmText: this.appService.translate('TD.restart_order'),
					}).then(() => {
						this.restartOrder(true);
					}).catch(err => {
						this.cancelOrder();
					});
					break;
				case "expired":
					this.appService.alert({
						content: this.appService.translate('TD.msg_expired'),
					}).then(() => {
						this.cancelOrder();
					})
					break;
			}
		});
	}

	translationSubscription;
	checkoutSubscription;
	currentLocal;
	ngOnInit() {
		console.log(this.currentRoute);
	}

	ngOnDestroy(ev?) {
		this.translationSubscription?.unsubscribe();
		this.orderService.clearOrder();
		this.checkoutSubscription?.unsubscribe();
	}
	toggleAppSidenav() {
		this.appSidenav.toggle();
	}
	onSideNvaAction($event: any) {
		switch ($event) {
			case 'restartOrder': this.restartOrder(this.wizardStep === this.stepsMap.end); break;
			case 'checkout': this.checkout(); break;
			case 'signout': this.signOut(); break;
			case 'signin': this.signIn('sideNav'); break;
			case 'wallet': this.wallet(); break;
			case 'changeToPickup': this.orderService.changeOrderToPickup(); break;
		}
	}

	init(config?) {
		this.appService.startBlock();
		this.orderService.initTabitOrder(config).then((res) => {
			this.tabitPayService.$storage = {}
			this.orderService.startFullView();
			this.orderService.startActivityTimer();
			this.$storage = this.orderService.$storage;
			this.$storage.hasBack = this.$storage.hasBack || this.router.lastSuccessfulNavigation()?.extras?.state?.data?.hasBack;
			if (this.router.lastSuccessfulNavigation()?.extras?.state?.data?.isAnonymous) {
				this.$storage.anonymous = { anonymous: true};
			}

			this.stepsMapTitles[0] = this.$storage.config.name;
			this.stepsMapTitles[1] = this.appService.objTranslate('extraOffersCaption', this.$storage.config.settings, 'TD.additional_offers');
			this.appService.stopBlock();
			this.loading = false;
			if (this.$storage.orderStep) {
				this.wizardStep = this.$storage.orderStep;
				this.hasExtras = this.$storage.extraOffersParsed != null;
			}
			if (this.$storage.wasStarted) {
				this.loyaltyService.restoreLoyalty();
			} else {
				this.$storage.currentRoute = this.activatedRoute.snapshot.url.map(segment => segment.path).join('/');
				this.$storage.menuDisabled = this.$storage.currentRoute === 'opentab';

				console.log(`__ ${this.$storage.currentRoute} __`);
				this.loyaltyService.getCustomerAutoLogin(this.$storage).then(res => {
					if (res) {
						this.showLoyaltyDialog()
					}
				});
				setTimeout(() => {this.start()}, 500);
			}
			if (!this.currentLocal) {
				this.translationSubscription = this.appService.translation$.subscribe(newLocal => {
					if (this.currentLocal && !this.loading && this.currentLocal != newLocal) {
						this.onTranslationChange(newLocal);
					}
				});
			}
			if (!this.checkoutSubscription) {
				this.checkoutSubscription = this.orderService.checkoutTrigger$.subscribe(from  => {
					if (from) {
						this.checkout(from);
					}
				});
			}
			this.currentLocal = this.appService.locale;
		}).catch(err => {
			console.error('ERROR', err);
			this.appService.stopBlock();
			if (err?.type != 'CANCELED') {
				this.appService.alert({html: this.appService.translate(err?.log  || 'TD.service_unavailable')});
			}
			if (this.appService.urlParams.virtualSite) {
				this.router.navigate(['/tabit']);
			}else {
				this.router.navigate(['/pay/tabit-pay']);
			}
		});
	}

	async onTranslationChange(newLocal) {
		this.currentLocal = newLocal;
		this.appService.startBlock();
		this.loading = true;
		delete this.$storage.extraOffersPrepared;
		await this.orderService.redrawCatalog();
		this.stepsMapTitles[0] = this.$storage.config.name;
		this.stepsMapTitles[1] = this.appService.objTranslate('extraOffersCaption', this.$storage.config.settings, 'TD.additional_offers');
		this.appService.stopBlock();
		this.loading = false;
	}

	start() {
		if (this.$storage.wasStarted) return;
		const hasBasket = this.$storage.basket.length;
		Promise.resolve().then(() => {
			if (!hasBasket && this.$storage.canCreateTabOrder && !this.$storage.hasBack) {
				//return this.dialogsService.showTabOrderOptions_fromOrder(this.$storage);
			}
			return true;
		}).then(wasContinued => {
			if (wasContinued) {
				if (this.appService.regionArgs.enableAutoLoyaltyLogin) {

				} else {
					this.$storage.hasLoyaltyOpt = this.loyaltyService.active && this.$storage.loyaltyClub;
				}

				/*if (!this.$storage.tipOptions) {
					this.stepsMapTitles[2] = this.stepsMapTitles[3]
				}*/
				this.$storage.wasStarted = true;
				this.orderService.cacheOrder();

				if (hasBasket) {
					this.checkout();
				} else if (this.$storage.hasLoyaltyOpt && this.$storage.config?.settings.autoPOPLoyaltyDialog) {
					this.showLoyaltyDialog().then(() => {
						//this.orderService.popMessages(this.$storage, 'inMenu').then(() => {})
					});
				} else {
					//this.orderService.popMessages(this.$storage, 'inMenu').then(() => {})
				}
			}
		})
	}

	checkoutClick() {
		this.menuComponent.gotoSummary();
	}

	showLoyaltyDialog() {
		return this.dialogsService.openLoyaltyDialog().then((res: any) => {
			switch (res?.mode) {
				case "signin": return this.showLoyaltyDialog(); break;
				case "signout": this.loyaltyService.signOut(this.$storage); break;
			}
			this.orderService.addLoyaltyToBasket(this.loyaltyService?.loyaltyMember?.offers);
			this.$storage.hasLoyalty = this.loyaltyService.loyaltyData;
		});
	}

	checkout(from?) {
		if (!this.$storage?.basket.length) {
			this.appService.alert({ content: 'TD.no_basket_items' });
			return;
		}
		return new Promise((resolve, reject) => {
			let bottomSheetRef = this.bottomSheet.open(TabitOrderSummaryComponent, {
				data: {
					isInCheckout: this.wizardStep > this.stepsMap.menu,
					canEditItems: this.wizardStep == this.stepsMap.menu,
				},
				direction: this.appService.direction,
				panelClass: "bottom-sheet-summary",
				disableClose: true
			});
			bottomSheetRef.afterDismissed().subscribe(result => {
				switch (result) {
					case 'next':
						this.dialog.closeAll();
						this.signIn('checkout').then(res => {
							this.hasExtras = this.orderService.getExtraOffers(this.$storage);
							this.goNext();
						}).catch(err => {
							/*this.appService.alert({ content: 'Dana: we should discuss what to do when login fails or cancelled, for now I return the user to the menu' }).then(() => {
								//this.router.navigate(['/pay/tabit-pay']);
							})*/
						});
						break;
					case 'menu':
						this.dialog.closeAll();
						this.setStepBack(this.stepsMap.menu);
						break;
					default:
						if (from != 'search') this.dialog.closeAll();
						resolve('');
				}
			});
			let canClose = false;

			bottomSheetRef.afterOpened().subscribe(result => {
				window.setTimeout(() => {
					canClose = true;
				}, 500);
			});

			bottomSheetRef.backdropClick().subscribe(result => {
				if (canClose) {
					bottomSheetRef.dismiss();
				}
			});
		});
	}

	//---------------------------------------------------------------------------------->
	//---------------------------------------------------------------------------------->

	onEndOrder(ev) {
		switch (ev) {
			case 'restart': this.restartOrder(true); break;
			default: this.router.navigate(['/pay/tabit-pay']);
		}
	}
	onOrderDone(ev?) {
		this.setStep(this.stepsMap.end);
	}

	//---------------------------------------------------------------------------------->
	//---------------------------------------------------------------------------------->

	goBack() {
		if (this.$storage.activeSubCat) {
			this.menuComponent.menuBackClick(this.$storage.activeSubCat);
		} else {

			switch (this.wizardStep) {
				case this.stepsMap.menu: ; case this.stepsMap.end: return this.cancelOrder();
				//case this.stepsMap.extraoffers: break;
				case this.stepsMap.tip:
					if (this.hasExtras) return this.setStepBack(this.stepsMap.extras);
					break;
				case this.stepsMap.pay:
					if (this.hasTipOptions()) return this.setStepBack(this.stepsMap.tip);
					else if (this.hasExtras) return this.setStepBack(this.stepsMap.extras);
					break;
			}
			this.setStepBack(this.stepsMap.menu);
		}
	}

	setStepBack(newStep) {
		//clear gratuity + taxes and fees
		if (newStep < this.stepsMap.tip) {
			delete this.$storage.gratuity;
			this.$storage.wasTaxesAndFees = false;
			this.orderProcess.clearBasketAdditions(this.$storage);
			this.orderService.calculateBasketTotal();
		}

		this.setStep(newStep);
	}

	//---------------------------------------------------------------------------------->

	goNext(ev?) {
		switch (this.wizardStep) {
			case this.stepsMap.menu:
				if (this.hasExtras) return this.setStepNext(this.stepsMap.extras);
				else if (this.hasTipOptions()) return this.setStepNext(this.stepsMap.tip);
				break;
			case this.stepsMap.extras:
				if (this.hasTipOptions()) return this.setStepNext(this.stepsMap.tip);
				break;
			//case this.stepsMap.tip:break;
		}
		this.setStepNext(this.stepsMap.pay);
	}

	setStepNext(newStep) {
		// calculate taxes and fees
		if (newStep >= this.stepsMap.tip && !this.$storage.wasTaxesAndFees) {
			return this.getBasketAdditions().then(() => {
				this.setStep(newStep);
				//if (this.$storage.order.loyaltyTotal)this.checkout();
			});
		}
		this.setStep(newStep);
	}
	hasTipOptions() {
		return this.$storage.tipOptions || (this.loyaltyService.loyaltyData?.pointsUsable && this.$storage.order.grandTotal);
	}

	//---------------------------------------------------------------------------------->

	setStep(newStep) {
		this.$storage.orderStep = newStep;
		this.$storage.isInCheckout = newStep > this.stepsMap.menu && newStep < this.stepsMap.end;
		this.orderService.cacheOrder();
		this.wizardStep = newStep;
	}
	reloadStep() {
		this.appService.startBlock({ class: 'dark-block' });
		let step = this.wizardStep;
		this.wizardStep = -1;
		setTimeout(() => {
			this.appService.stopBlock();
			this.wizardStep = step;
		})
	}

	//---------------------------------------------------------------------------------->

	async getBasketAdditions() {
		this.appService.startBlock({ text: '', class: 'dark-block' });
		try {
			await this.loyaltyService.getBenefits(this.$storage);
		} catch (e) {}

		return this.orderProcess.getBasketAdditions(this.$storage).then(() => {
			this.$storage.wasTaxesAndFees = true;
			this.orderService.calculateBasketTotal();
		}).catch (err => {
			this.orderService.showOrderError(err?.error);
			const errorCode = err.error?.code || err.code;
			switch (errorCode) { //already handoff
				case 409136:
					this.onOrderDone({});
					break;
			}
			throw (err);
		}).finally(() => {
			this.appService.stopBlock();
		});
	}

	//---------------------------------------------------------------------------------->

	restartOrder(silent?) {
		Promise.resolve().then(() => {
			if (!silent) {
				return this.appService.confirm({ content: 'TO.q_confirm_reset_order' });
			}
		}).then(() => {
			this.dialog.closeAll();
			this.loading = true;
			this.setStepBack(this.stepsMap.menu);
			this.orderService.clearOrder();
			this.orderService.initNewStorage();
			document.location.reload();
			//this.init();
		});
	}

	cancelOrder() {
		this.appService.goBack();
	}

	async signIn(from?: string) {
		if (this.appService.user || this.$storage.anonymous) return true;
		let requireSigning = false;
		switch (from) {
			case "sideNav": break;
			case "checkout":
				requireSigning = this.appService.regionArgs.requireLoginforAddItems;
				break;
		}
		const loginResponse = await this.dialogsService.login({hideSuccessAnim: true}, 'tabitOrder');
		if (loginResponse) {
			if (loginResponse?.anonymous) {
				this.$storage.anonymous = loginResponse;
			} else {
				delete this.$storage.anonymous;
				this.orderService.paymentService.createUserWalletPms(this.$storage);
				return this.loyaltyService.getCustomerAutoLogin(this.$storage).then(res => {
					if (res) {
						this.showLoyaltyDialog();
					} else {
						this.appService.animDialog({
							title: this.appService.translate('WELCOME_BACK', {name: this.appService.lUser?.FullName}),
							animation: 'check',
							titleClass: 'text-lg text-center'
						})
					}
				});
			}
		} else {
			if (requireSigning) {
				throw({});
			}
		}
	}

	async wallet() {
		if (!this.appService.user) true;
		return this.dialogsService.showWallet().then((res) => {
			this.orderService.paymentService.createUserWalletPms(this.$storage);
			if (this.wizardStep == this.stepsMap.pay) this.reloadStep();
		});
	}
	signOut() {
		return this.appService.confirm({ content: 'MESSAGES.CONFIRM_SIGNOUT' }).then((res) => {
			this.appService.startBlock();
			delete this.$storage.wallet;
			this.loyaltyService.autoLoginSignOut(this.$storage);
			this.authService.signOut().then(() => {
				this.setStepBack(this.stepsMap.menu);
			}).finally(() => {
				this.appService.stopBlock();
			})
		}).catch(err => { });
	}

	searchCatalog() {
		this.menuComponent.searchCatalog().then((res) => {
			if (res?.action === 'checkout') {
				this.checkout()
			}
		});
	}

	async toggleTranslation() {
		this.appService.toggleTranslation();
		this.appService.startBlock();
		this.loading = true;
		delete this.$storage.extraOffersPrepared;
		await this.orderService.redrawCatalog();
		this.stepsMapTitles[0] = this.$storage.config.name;
		this.stepsMapTitles[1] = this.appService.objTranslate('extraOffersCaption', this.$storage.config.settings, 'TD.additional_offers');
		this.appService.stopBlock();
		this.loading = false;
	}

}
